import styled from 'styled-components'
import { FilterOption } from '../../components'
import { translate } from '../../utils/filterDrawer/traslationByKeys'

const Container = styled.div`
  display: flex;
  gap: 8px;
`

const GroupedFilterTags = ({ tags, onTagClick, maxTagsToShow = 4 }) => {
  const renderTags = ({ tags, onTagClick }) => {
    const newTagList = tags.slice(0, maxTagsToShow)

    return newTagList.map(tag => (
      <FilterOption
        key={tag}
        name={translate(tag)}
        onClick={onTagClick}
        isSelected={true}
        maxTextSize={120}
      />
    ))
  }

  return (
    <Container>
      <span>Filtros:</span>
      {renderTags({ tags, onTagClick })}
      {tags.length > maxTagsToShow && (
        <FilterOption
          key={'filterSizeCount'}
          name={`+${tags.length - maxTagsToShow}`}
          onClick={onTagClick}
          isSelected={true}
        />
      )}
    </Container>
  )
}

export default GroupedFilterTags
